document.addEventListener('DOMContentLoaded', () => {
    initApp();
});

const initApp = () => {
    menuHamburguer();
    faq();
    tabs();
    contact();
}

const menuHamburguer = () => {
    const openMenu = document.querySelector('.navbar__hamburguer');
    const navbar = document.querySelector('.navbar');
    const closeMenu = document.querySelector('.navbar__close');

    openMenu.addEventListener('click', () => {
        navbar.classList.add('active');
    });

    closeMenu.addEventListener('click', () => {
        navbar.classList.remove('active');
    })

}

const faq = () => {
    const items = document.querySelectorAll('.faq__item');
    items.forEach( element => {
        element.addEventListener('click', e => {
            element.classList.toggle('active');
            const item = element.lastElementChild;
            let height = 0;

            if(item.clientHeight === 0){
                height = item.scrollHeight;
            }

            item.style.height = `${height}px`;
        });
    } );
}

const tabs = () => {
    const tabs = document.querySelectorAll('.features__item');
    const items = document.querySelectorAll('.features__info');

    tabs.forEach( (element, index) => {
        element.addEventListener('click', () => {
            tabs.forEach( (element, index) => {
                element.classList.remove('active');
                items[index].classList.remove('active');
                setTimeout(() => {
                    items[index].classList.remove('visible');
                }, 100)
            })
            element.classList.add('active');
            items[index].classList.add('active');
            setTimeout(() => {
                items[index].classList.add('visible');
            }, 100)
        });
    })
}

const contact = () => {
    const regex = /^[\w\.\-\_]+@[\w]+\.[\w]+$/;
    const input = document.querySelector('.contact__input');
    const formGroup = document.querySelector('.contact__formgroup');
    const button = document.querySelector('.contact__cta');

    input.addEventListener('input', e => {

        if(e.target.value === ''){
            empty(formGroup);
        }else{
            if(regex.test(e.target.value)){
                removeError(formGroup);
            }else{
                showError(formGroup, "Whoops, make sure it's an email")
            }
        }
    });

    button.addEventListener('click', e => {
        e.preventDefault();

        if(input.value === ''){
            showError(formGroup, "Can't be blank!");
        }else{
            if(!formGroup.classList.contains('error')){
                input.value = '';
                Swal.fire(
                    'Good job!',
                    'You have subscribed successfully!',
                    'success'
                  );
            }
        }
    })

}

const showError = (formGroup, text) => {
    const textError = document.createElement('p');
    textError.classList.add('contact__error');
    textError.textContent = text;
    formGroup.classList.add('error');
    
    if(!formGroup.lastElementChild.classList.contains('contact__error')){
        formGroup.appendChild(textError);
    }else{
        formGroup.lastElementChild.textContent = text;
    }

}

const removeError = (formGroup) => {
    formGroup.classList.remove('error');

    if(formGroup.lastElementChild.classList.contains('contact__error')){
        formGroup.lastElementChild.remove();
    }
}

const empty = (formGroup) => {
    formGroup.classList.remove('error');
    formGroup.lastElementChild.remove();
}